<div class="overlay" *ngIf="showBoat" (click)="showBot()"></div>
<div class="chatbot" (click)="showBot()">
  <svg color="inherit" viewBox="0 0 32 32" class="chat-bot-icon">
    <path fill="#FFFFFF"
      d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46">
    </path>
    <path fill="#0059E1"
      d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z"
      class="chat-bot-rec"></path>
    <path class="chatbot-inner-shape" style="z-index: 1"
      d="M10.1323 14.052C9.61464 13.873 9 14.1779 9 14.6347V16.9776C9 17.3027 9.21685 17.6019 9.57923 17.7403C10.6835 18.1618 13.228 19 16.0001 19C18.7721 19 21.3166 18.1618 22.4209 17.7403C22.7833 17.6019 23 17.3027 23 16.9776V14.6347C23 14.1779 22.3855 13.873 21.8678 14.052C20.5905 14.4935 18.3791 15.1109 16.0001 15.1109C13.621 15.1109 11.4096 14.4935 10.1323 14.052Z"
      fill="#FFFFFF"></path>
  </svg>
  <div class="message-icon">
    <svg viewBox="0 0 60 40" width="18px" fill="#0059E1">
      <circle r="6" cy="20" cx="9" class="message-circle message-circle-first"></circle>
      <circle r="6" cy="20" cx="30" class="message-circle message-circle-second"></circle>
      <circle r="6" cy="20" cx="51" class="message-circle message-circle-third"></circle>
    </svg>
  </div>
</div>

<!-- Chatbot Popup -->
<div class="chatbot-popup" [class.open]="showBoat" [class.fullscreen]="isExpaned">
  <!-- Chat Header -->
  <div class="chatbot-popup-header">
    <h6>AI Assistant </h6>
    <div class="chatbot-popup-header-buttons">
      <button id="chatHelp" class="chatbot-popup-header-expand card-popover"
      title="<b>Questions hint..<b>" data-toggle="popover"
      [attr.data-bs-html]="true" [attr.data-bs-content]="getMsg()"
      (mouseover)="Popup($event)"
      >
        <i class="fa-solid fa-info"></i>
      </button>
      <button id="expand-chat" class="chatbot-popup-header-expand" (click)="expandBot()">
        <i [ngClass]="{
            'bi bi-arrows-angle-contract': isExpaned,
            'bi bi-arrows-angle-expand': !isExpaned
          }"></i>
      </button>
      <button id="close-chat" class="chatbot-popup-header-close" (click)="showBot()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>

  <!-- Chat Content -->
  <div class="chatbot-popup-content overflow-auto" id="chatBox">
    <div class="chat-botMsg" *ngIf="chatMsg.length < 2" #ChatHelpertemplate>
      <h6>Ask questions like :</h6>
      <p><small>
        <b>Use keyword :  "difference" , "changes", "new", "short", "describe", "explain", "details"
        </b></small></p>
        <b>Questions like :</b>
        <span class="rounded-3 text-dark bg-light">
          <p><b>Q. 1 : </b> Explain amendment to rule 67 in <b> <i> short</i></b>.</p>
        </span>
        <span class="rounded-3 text-dark bg-light">
          <p><b>Q. 2 : </b> What are the <b><i>changes</i></b> in rule 70 ?</p>
        </span>
    </div>
    <ng-template class=" mb-2 p-2 rounded-3 text-white bg-primary" #userMsg>
      {{userMessage}}
    </ng-template>
    <div class="chat" *ngFor="let msg of chatMsg">
      <div class="chat-userMsg" *ngIf="msg.useRequest;else userMsg">
        <div class="mb-2 p-2 rounded-3 text-white">
          {{ msg.useRequest }}
        </div>
        <button *ngIf="msg.useRequest" class="btn btn-sm" (click)="copyToClipboard(msg.useRequest)" title="Copy">
          <i class="bi bi-copy"></i>
        </button>
      </div>
      <div class="chat-botMsg" *ngIf="msg.botResponse">
        <div class=" mb-2 p-2 rounded-3 text-dark bg-light">
          {{ msg.botResponse }}
        </div>
        <button *ngIf="msg.botResponse" class="btn btn-sm" (click)="copyToClipboard(msg.botResponse)" title="Copy">
          <i class="bi bi-copy"></i>
        </button>
        <button class="btn btn-light" (click)="readResponse(msg.botResponse)" title="Read Message">
          <i class="bi bi-volume-up"></i>
        </button>
      </div>
    </div>
    <div class="chat-botMsgs mt-5 mb-2 p-2 rounded-3 text-dark bg-light" *ngIf="loadingResponse">
      <div class="spinner-grow spinner-grow-sm text-primary spinner1" role="status"></div>
      <div class="spinner-grow spinner-grow-sm text-primary spinner2" role="status"></div>
      <div class="spinner-grow spinner-grow-sm text-primary spinner3" role="status"></div>
    </div>
  </div>
  <!-- Chat Input -->
  <div class="chatbot-popup-input">
    <input type="text" class="form-control" id="userMessage" #inputUser placeholder="Type a message..."
      (keydown.enter)="sendMsg(inputUser)" autocomplete="off" />
    <button type="button" class="btn" (click)="sendMsg(inputUser)" [disabled]="!sendBtn">
      <i class="fa-solid fa-paper-plane"></i>
    </button>
    <button (click)="startVoiceInput()" class="btn btn-primary" title="Speak">
      <i class="fa-solid fa-microphone "></i>
    </button>
  </div>
</div>